import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export default function AdminSalesSwitches() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/sales/switches").then(({ data }) => setRows(data)); }, []);
  const flip = async (r, on) => {
    try {
      const { data } = await api.post("/admin/sales/switches", { key: r.key, on });
      setRows(data);
      toast.success(`${r.label} ${on ? "on sale" : "set to Coming soon"}`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="glass rounded-2xl p-6 mb-6" data-testid="admin-sales-switches">
      <p className="font-display text-lg text-amber-100">What's on sale</p>
      <p className="text-xs text-slate-400 mb-4">Anything switched off stays visible in the store with a "Coming soon" button and can't be bought.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {rows.map((r) => (
          <label key={r.key} className="flex items-center justify-between gap-3 rounded-xl border border-slate-700 px-4 py-3 cursor-pointer" data-testid={`sale-switch-${r.key}`}>
            <span className="text-sm text-slate-200">{r.label}<span className={`block text-[11px] ${r.on ? "text-emerald-300" : "text-slate-500"}`} data-testid={`sale-switch-${r.key}-state`}>{r.on ? "On sale" : "Coming soon"}</span></span>
            <Switch checked={r.on} onCheckedChange={(v) => flip(r, v)} data-testid={`sale-switch-${r.key}-toggle`} />
          </label>
        ))}
      </div>
    </div>
  );
}
